import uniSwapImage from '../../images/uni-swap.png';
import amasaImage from '../../images/amasa-with-text.png';
import connectImage from '../../images/connect.svg';
import {Button, IconButton} from '@mui/material';
import styles from './header.module.css';
import React, {useEffect} from 'react';
import ConnectionDialog from '../connection-dialog/connection-dialog';
import {useWeb3React} from '@web3-react/core';
import config from '../../config/config';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';

function Header() {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        open && (document.body.style.overflow = 'hidden');
        !open && (document.body.style.overflow = 'unset');
    }, [open]);

    const [connectionDialogOpen, setConnectionDialogOpen] = React.useState(false);

    const handleConnectionDialogOpen = () => {
        setConnectionDialogOpen(true);
    };

    const handleConnectionDialogClose = () => {
        setConnectionDialogOpen(false);
    };

    const {account, activate} = useWeb3React();

    useEffect(() => {
        activateProvider();
    });

    return (
        <div>
            <ConnectionDialog
                open={connectionDialogOpen}
                handleConnectionDialogClose={handleConnectionDialogClose}
            />
            <div className={`${styles.container}`}>
                <IconButton className={`${styles.image}`} onClick={() => {
                    window.open('https://www.amasa.io/');
                }
                }>
                    <img className={`${styles.imageWithText}`} alt="" src={amasaImage}/>
                </IconButton>
                <div className={`${styles.allButtons}`}>
                    <div className={`${styles.uniSwapButton}`} onClick={() =>
                        window.open(
                            "https://app.uniswap.org/#/add/v2/0x65a8fba02f641a13bb7b01d5e1129b0521004f52/ETH"
                        )
                    }>
                        <Button className={`${styles.button}`}>
                            <div className={`${styles.uniSwapButtonIcon}`}>
                                <img alt="" src={uniSwapImage}/>
                            </div>
                            <div className={`${styles.uniSwapButtonText}`}>
                                {'Uniswap | Amasa <> ETH'}
                            </div>
                        </Button>
                    </div>
                    <div className={`${styles.connectButton}`} onClick={handleConnectionDialogOpen}>
                        <Button
                            title={account === undefined || account === null ? '' : account}
                            className={`${styles.button}`}
                        >
                            <div className={`${styles.connectButtonIcon}`}>
                                <img alt="" src={connectImage}/>
                            </div>
                            <div className={`${styles.connectButtonText}`}>
                                {account === undefined || account === null
                                    ? 'Connect Wallet'
                                    : account
                                        ? `${account.substring(0, 6)}...${account.substring(
                                            account.length - 4,
                                        )}`
                                        : ''}
                            </div>
                        </Button>
                    </div>
                </div>
                <div
                    className={styles.menu}
                    onClick={() => {
                        setOpen(!open);
                    }}
                >
                    {open ? (
                        <CloseIcon fontSize={'large'}/>
                    ) : (
                        <MenuIcon fontSize={'large'}/>
                    )}
                </div>
                {open ? (
                    <div className={styles.dropdown}>
                        <div className={`${styles.uniSwapButton} ${styles.maxWidth}`} onClick={() =>
                            window.open(
                                "https://app.uniswap.org/#/add/v2/0x65a8fba02f641a13bb7b01d5e1129b0521004f52/ETH"
                            )
                        }>
                            <Button className={`${styles.button}`}>
                                <div className={`${styles.uniSwapButtonIcon}`}>
                                    <img alt="" src={uniSwapImage}/>
                                </div>
                                <div className={`${styles.uniSwapButtonText}`}>
                                    {'Uniswap | Amasa <> ETH'}
                                </div>
                            </Button>
                        </div>
                        <div className={`${styles.connectButton} ${styles.maxWidth}`}
                             onClick={handleConnectionDialogOpen}>
                            <Button
                                title={account === undefined || account === null ? '' : account}
                                className={`${styles.button}`}
                            >
                                <div className={`${styles.connectButtonIcon}`}>
                                    <img alt="" src={connectImage}/>
                                </div>
                                <div className={`${styles.connectButtonText}`}>
                                    {account === undefined || account === null
                                        ? 'Connect Wallet'
                                        : account
                                            ? `${account.substring(0, 6)}...${account.substring(
                                                account.length - 4,
                                            )}`
                                            : ''}
                                </div>
                            </Button>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );

    function activateProvider() {
        const currentProvider = localStorage.getItem('currentProvider');
        if (currentProvider === undefined || currentProvider === null) {
            return;
        }
        let provider = null;
        if (currentProvider === 'Metamask') {
            provider = config.connectors.Injected;
        } else if (currentProvider === 'WalletConnect') {
            provider = config.connectors.WalletConnect;
        }
        if (provider != null) {
            if (account === undefined) {
                activate(provider);
            }
        }
    }
}

export default Header;
